import React from 'react'
import { Modal, Form, Input, Select, Tooltip } from 'antd'
import { QuestionCircleOutlined } from '@ant-design/icons'
import { useAtomMethod } from '@/helper/hooks/atom-method-hook/useAtomMethod'
import { userinfoService } from '@/common/services/userinfo/userinfoService'

interface ModalChangePasswordProps {
	visible: boolean
	onCancel: () => void
	onOk: (val: any) => void
}

const PASSWORD_RULE_PATTERN = /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])(?=.*[^A-Za-z0-9\s])\S{12,20}$/
const PASSWORD_RULE_MESSAGE = '密码需为12-20位，且同时包含数字、大写字母、小写字母、特殊符号'

const ModalChangePassword: React.FC<ModalChangePasswordProps> = ({
	visible,
	onCancel,
	onOk
}) => {
	const [useInfo] = useAtomMethod(userinfoService.userInfo)
	const [form] = Form.useForm()

	const handleCancel = () => {
		onCancel()
		form.resetFields()
	}
	const handleOk = () => {
		form.validateFields().then((values) => {
			onOk({ ...values })
			form.resetFields()
		}).catch((err) => {
			console.warn('修改密码表单校验失败');
		})
	}

	return (
		<Modal
			title="设置密码"
			open={visible}
			onCancel={handleCancel}
			onOk={handleOk}
			// destroyOnClose
		>
			<Form form={form} layout="vertical" initialValues={{ passwordRemindDays: useInfo?.passwordRemindDays || 90 }}>
				{useInfo?.isPassword ? (
					<Form.Item
						name="oldPassword"
						label="原密码"
						rules={[{ required: true, message: '请输入原密码!' }]}
					>
						<Input.Password />
					</Form.Item>
				) : (
					''
				)}
				<Form.Item
					name="newPassword"
					label="新密码"
					rules={[
						{ required: true, message: '请输入新密码!' },
						{ pattern: PASSWORD_RULE_PATTERN, message: PASSWORD_RULE_MESSAGE }
					]}
				>
					<Input.Password />
				</Form.Item>
				<Form.Item
					name="confirmPassword"
					label="确认密码"
					dependencies={['newPassword']}
					rules={[
						{
							required: true,
							message: '请确认新密码!'
						},
						({ getFieldValue }) => ({
							validator(rule, value) {
								if (!value || getFieldValue('newPassword') === value) {
									return Promise.resolve()
								}
								return Promise.reject('确认密码与新密码不一致!')
							}
						})
					]}
				>
					<Input.Password />
				</Form.Item>
				<Form.Item
					name="passwordRemindDays"
					label={(
						<span>
							账号校验周期
							<Tooltip title={'自定义账号的固定校验周期，系统将依据设定时间自动发起身份复核。在周期校验时，既可通过输入当前密码完成快速身份确认，也可直接修改密码，实现安全与便捷的自主平衡。'}>
								<QuestionCircleOutlined style={{ marginLeft: 4 }} />
							</Tooltip>
						</span>
					)}
					rules={[{ required: true, message: '请选择账号校验周期' }]}
				>
					<Select
						options={[
							{ label: '90天', value: 90 },
							{ label: '180天', value: 180 },
							{ label: '365天', value: 365 },
						]}
					/>
				</Form.Item>
			</Form>
		</Modal>
	)
}

export default ModalChangePassword
